var style = [
    {
        "featureType": "all",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#ff7b00"
            },
            {
                "saturation": "-35"
            },
            {
                "lightness": "20"
            },
            {
                "gamma": "1.09"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
            {
                "saturation": "-100"
            },
            {
                "weight": "0.01"
            },
            {
                "lightness": "-49"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "saturation": "-100"
            },
            {
                "lightness": "10"
            },
            {
                "gamma": "0.97"
            }
        ]
    }
];

var apiKey = '';
if (comedien && comedien.api && typeof comedien.api.googleMapsKey !== "undefined") {
    apiKey = comedien.api.googleMapsKey;
}

module.exports = {
    style: style,
    apiKey: apiKey,
};
